import './Home.css'
import { Link } from "react-router-dom";
import React, { useEffect } from 'react';

function Titulo() {
  useEffect(() => {
    document.title = 'Carreras Documentadas';
  }, []);
}

export default function Home()
{
    return(
      <>
      <Titulo />
        <section className="main">
          <div className='contenedor'>

            <div className='cards'>
              <div className='cover'>
                <img src='https://cdn131.picsart.com/c079c48b-8d73-4472-823c-90e00237fc15/406593583005211.png' />
                <div className='background'></div>
              </div>
              <div className='description'>
                <h2>Lionel Messi</h2>
                <Link to='/Jugadores/Messi'><input type='button' value='Ver Más'/></Link>
              </div>
            </div>

            <div className='cards'>
              <div className='cover'>
                <img src='https://pbs.twimg.com/media/DgA3DPBXkAEN1I7?format=png&name=large' />
                <div className='background'></div>
              </div>
              <div className='description'>
                <h2>Cristiano Ronaldo</h2>
                <Link to='/Jugadores/Ronaldo'><input type='button' value='Ver Más'/></Link>
              </div>
            </div>

            <div className='cards' style={{display: "none"}}>
              <div className='cover'>
                <img src='https://stories.infobae.com/wp-content/uploads/2023/02/Diego-Maradona-FootyRenders.png' />
                <div className='background'></div>
              </div>
              <div className='description'>
                <h2>Diego Maradona</h2>
                <Link to='/Jugadores/Maradona'><input type='button' value='Ver Más'/></Link>
              </div>
            </div>

            <div className='cards'>
              <div className='cover'>
                <img src='https://www.footyrenders.com/render/Pele-Brazil.png' />
                <div className='background'></div>
              </div>
              <div className='description'>
                <h2>Pelé</h2>
                <Link to='/Jugadores/Pele'><input type='button' value='Ver Más'/></Link>
              </div>
            </div>

          </div>
        </section>
        </>
    )
}
